import {
  AccountantTreasurerIcon,
  ApproveIcon,
  CartNewIcon,
  PlanBlueIcon,
  PlanIcon,
  PlayIcon,
  ReportIcon,
  StarNewIcon,
  SystemIcon,
  LockIcon,
} from 'assets/svg';
import { PowerBiComponent } from 'components/PowerBi/PowerBiComponent';
import { useUser } from 'contexts/UserProvider';
import HandoverPage from 'pages/Accountant/Handover/HandoverPage';
import DetailPaymentSummaryPage from 'pages/Accountant/PaymentSummary/DetailPaymentSummary/DetailPaymentSummaryPage';
import PaymentSummaryPage from 'pages/Accountant/PaymentSummary/PaymentSummaryPage';
import PaymentInfoPage from 'pages/Accountant/PaymentInfo/PaymentInfoPage';
import PaymentSummaryPageV2 from 'pages/Accountant/PaymentSummaryV2/PaymentSummaryPageV2';
import DetailPaymentSummaryPageV2 from 'pages/Accountant/PaymentSummaryV2/DetailPaymentSummaryV2/DetailPaymentSummaryPageV2';
import AddPurchaseInvoice from 'pages/Accountant/PurchaseInvoicePage/AddNewPurchase/AddPurchaseInvoice';
import SeparatePurchaseInvoice from 'pages/Accountant/PurchaseInvoicePage/PurchaseInvoiceDetailPage/Separate/SeparatePurchaseInvoice';
import PurchaseInvoicePage from 'pages/Accountant/PurchaseInvoicePage/PurchaseInvoicePage';
import RouteCostPage from 'pages/Accountant/RouteCost/RouteCostPage';
import SalesInvoiceDetailPage from 'pages/Accountant/SalesInvoicePage/SalesInvoiceDetailPage/SalesInvoiceDetailPage';
import SalesInvoicePage from 'pages/Accountant/SalesInvoicePage/SalesInvoicePage';
import EinvoiceHistoryPage from 'pages/Accountant/EinvoiceHistory/EinvoiceHistoryPage';
import CustomerApprove from 'pages/Approve/ApproveList/ApproveDetail/CustomerApprove';
import PriceOrderApprove from 'pages/Approve/ApproveList/ApproveDetail/PriceOrderApprove';
import PricePurchaserApprove from 'pages/Approve/ApproveList/ApproveDetail/PricePurchaserApprove';
import ApproveList from 'pages/Approve/ApproveList/ApproveList';
import CNFollowPlan from 'pages/Operate/CNFollowCustomer/CNFollowPlan';
import CNFollowPlanDetail from 'pages/Operate/CNFollowCustomer/CNFollowPlantDetail';
import EmployeeRouteTracking from 'pages/Operate/EmployeeRouteTracking/EmployeeRouteTracking';
import HOFollowPlan from 'pages/Operate/HOFollowPlan/HOFollowPlan';
import HOFollowPlanDetail from 'pages/Operate/HOFollowPlan/HOFollowPlanDetail';
import CNPlan from 'pages/Plant/CNPlan/CNPlan';
import CNPlanDetail from 'pages/Plant/CNPlan/CNPlanDetail';
import CustomerPage from 'pages/Plant/Customer/CustomerPage';
import HOPlan from 'pages/Plant/HOPlan/HOPlan';
import HOPlanDetail from 'pages/Plant/HOPlan/HOPlanDetail';
import SaleLinePage from 'pages/Plant/SaleLine/SaleLinePage';
import SaleLineTeam from 'pages/Plant/SaleLineTeam/SaleLineTeam';
import TeamDashboard from 'pages/Plant/SalePlan/Dashboard/TeamDashboard';
import SalePlan from 'pages/Plant/SalePlan/SalePlan';
import SaleTeamPage from 'pages/Plant/SaleTeamPage/SaleTeamPage';
import ProductDetail from 'pages/Product/ProductDetail/ProductDetail';
import ProductList from 'pages/Product/ProductList/ProductList';
import ProductSlocListPage from 'pages/Product/ProductSloc/ProductSlocListPage';
import CustomerGroupRevenuePage from 'pages/Report/CustomerGroupRevenue/CustomerRevenuePage';
import CustomerRevenuePage from 'pages/Report/CustomerRevenue/CustomerRevenuePage';
import MarketCoveragePage from 'pages/Report/MarketCoverage/MarketCoveragePage';
import SaleLineEfficiencyPage from 'pages/Report/SaleLineEfficiency/SaleLineEfficiencyPage';
import TeamRevenuePage from 'pages/Report/TeamRevenue/TeamRevenuePage';
import TeamSaleRevenuePage from 'pages/Report/TeamSaleRevenue/TeamSaleRevenuePage';
import TransactionFrequencyPage from 'pages/Report/TransactionFrequency/TransactionFrequencyPage';
import GrossProfitPage from 'pages/RevenueReward/GrossProfit/GrossProfitPage';
import GroupRolePage from 'pages/RevenueReward/GroupRole/GroupRolePage';
import RewardCalculationPage from 'pages/RevenueReward/RewardCalculation/RewardCalculationPage';
import RewardCalculationSetupPage from 'pages/RevenueReward/RewardCalculationSetup/RewardCalculationSetupPage';
import RewardInfoPage from 'pages/RevenueReward/RewardInfo/RewardInfoPage';
import AverageOrder from 'pages/System/AverageOrder/AverageOrder';
import GoldPriceManagementPage from 'pages/System/GoldPriceManagement/GoldPriceManagementPage';
import PermissionPage from 'pages/System/Permission/PermissionPage';
import SaleDeal from 'pages/System/SaleDeal/SaleDealPage';
import ApprovalAdjusterPage from 'pages/System/SetApprovalPage/ApprovalAdjusterPage/ApprovalAdjusterPage';
import DetailSetApproval from 'pages/System/SetApprovalPage/DetailSetApproval';
import SetApprovalPage from 'pages/System/SetApprovalPage/SetApprovalPage';
import UpdateRole from 'pages/System/UpdateRole/UpdateRolePage';
import BranchConfigPage from 'pages/System/BranchConfig/BranchConfigPage';
import TerroristList from 'pages/Terrorist/TerroristList';
import TerroristVerification from 'pages/Terrorist/TerroristVerification';
import { useMemo } from 'react';
import path from 'routes/Path';
import { POWERBI_ID } from 'utils/constants/constant';
import { icons } from 'utils/constants/icons';
import DebtLimitPage from 'pages/Debt/DebtLimitPage';
import DebtDMSPage from 'pages/Debt/DebtDMSPage';
import DebtDMSDetailPage from 'pages/Debt/DebtDMSDetailPage';
import DebtCustomerDetailPage from 'pages/Debt/DebtCustomerDetailPage';

const { ShoppingCartOutlined } = icons;

interface RouteMenu {
  title: string;
  key: string;
  icon: JSX.Element;
  activeIcon?: JSX.Element;
  children?: any[];
}

interface RouteItem {
  title: string;
  path: string;
  element: () => JSX.Element;
  isHidden?: boolean;
}

const ROUTES: {
  [key: string]: RouteMenu;
} = {
  PLANT: {
    title: 'Kế hoạch',
    key: 'plant',
    icon: <PlanIcon />,
    activeIcon: <PlanBlueIcon />,
  },
  PRODUCT: {
    title: 'Sản phẩm',
    key: 'product',
    icon: <CartNewIcon />,
  },
  REPORT: {
    title: 'Báo cáo',
    key: 'report',
    icon: <ReportIcon />,
  },
  OPERATION: {
    title: 'Vận hành',
    key: 'operation',
    icon: <PlayIcon />,
  },
  APPROVE: {
    title: 'Phê Duyệt',
    key: 'approve',
    icon: <ApproveIcon />,
  },
  SYSTEM: {
    title: 'Hệ thống',
    key: 'system',
    icon: <SystemIcon />,
  },
  REVENUE_REWARD: {
    title: 'Doanh thu/ Thưởng',
    key: 'revenue_reward',
    icon: <StarNewIcon />,
  },
  ACCOUNTANT_TREASURER: {
    title: 'Kế toán/thủ quỹ',
    key: 'accountant_treasurer',
    icon: <AccountantTreasurerIcon />,
  },
  AML: {
    title: 'Phòng chống khủng bố',
    key: 'aml',
    icon: <LockIcon />, // using LockIcon to represent security/AML
  },
};
const ROUTE_ITEMS: {
  [key: string]: {
    [key: string]: RouteItem;
  };
} = {
  PLANT: {
    HO_PLAN: {
      title: '[HO] Kế hoạch',
      path: path.HO_PLAN,
      element: HOPlan,
    },
    HO_PLAN_DETAIL: {
      title: '[HO] Kế hoạch - Chi tiết',
      path: path.HO_PLAN_DETAIL,
      element: HOPlanDetail,
      isHidden: true,
    },
    CN_PLAN: {
      title: '[CN] Kế hoạch',
      path: path.CN_PLAN,
      element: CNPlan,
    },
    CN_PLAN_DETAIL: {
      title: '[CN] Kế hoạch - Chi tiết',
      path: path.CN_PLAN_DETAIL,
      element: CNPlanDetail,
      isHidden: true,
    },
    SALE_TEAM: {
      title: 'Đội bán hàng',
      path: path.SALE_TEAM,
      element: SaleTeamPage,
    },
    SALE_LINE: {
      title: 'Tuyến bán hàng',
      path: path.SALE_LINE,
      element: SaleLinePage,
    },
    SALE_LINE_TEAM: {
      title: 'Tuyến - Đội bán hàng',
      path: path.SALELINETEAM,
      element: SaleLineTeam,
    },
    SALE_PLAN: {
      title: 'Lập kế hoạch bán hàng',
      path: path.SALE_PLAN,
      element: SalePlan,
    },
    TEAM_DASHBOARD: {
      title: 'Dashboard đội bán hàng',
      path: path.TEAM_DASHBOARD,
      element: TeamDashboard,
      isHidden: true,
    },
    CUSTOMER: {
      title: 'Khách hàng',
      path: path.CUSTOMER,
      element: CustomerPage,
    },
  },
  PRODUCT: {
    PRODUCT: {
      title: 'Sản phẩm',
      path: path.PRODUCT,
      element: ProductList,
    },
    PRODUCT_SLOC: {
      title: 'Sản phẩm tồn kho theo Sloc',
      path: path.PRODUCT_SLOC,
      element: ProductSlocListPage,
    },
    PRODUCT_DETAIL: {
      title: 'Sản phẩm tồn kho theo Sloc - Chi tiết',
      path: path.PRODUCT_DETAIL,
      element: ProductDetail,
      isHidden: true,
    },
  },
  REVENUE_REWARD: {
    REWARD_CALC: {
      title: 'Bảng thưởng tháng',
      path: path.REWARD_CALC,
      element: RewardCalculationPage,
    },
    REWARD_CALC_SETUP: {
      title: 'Điều kiện thưởng',
      path: path.CALC_REWARD_SETUP,
      element: RewardCalculationSetupPage,
    },
    GROSS_PROFIT: {
      title: 'Lãi gộp',
      path: path.GROSS_PROFIT,
      element: GrossProfitPage,
    },
    GROUP_ROLE: {
      title: 'Nhóm và chức vụ quản lý',
      path: path.GROUP_ROLE,
      element: GroupRolePage,
    },
    REWARD_INFO: {
      title: 'Thông tin nhân viên',
      path: path.REWARD_INFO,
      element: RewardInfoPage,
    },
  },
  REPORT: {
    OVERVIEW_REPORT: {
      title: 'Báo cáo tổng quan',
      path: path.OVERVIEW_REPORT,
      element: () => (
        <PowerBiComponent
          myReport={POWERBI_ID.OVERVIEW_REPORT}
          title={'Báo cáo tổng quan'}
        />
      ),
    },
    CUSTOMER_REPORT: {
      title: 'Báo cáo khách hàng',
      path: path.CUSTOMER_REPORT,
      element: () => (
        <PowerBiComponent
          myReport={POWERBI_ID.CUSTOMER_REPORT}
          title={'Báo cáo khách hàng'}
        />
      ),
    },
    TEAM_REVENUE: {
      title: 'Doanh thu đội',
      path: path.TEAM_REVENUE,
      element: TeamRevenuePage,
    },
    CUSTOMER_REVENUE: {
      title: 'Doanh thu khách hàng',
      path: path.CUSTOMER_REVENUE,
      element: CustomerRevenuePage,
    },
    CUSTOMER_GROUP_REVENUE: {
      title: 'Doanh thu theo nhóm khách hàng',
      path: path.CUSTOMER_GROUP_REVENUE,
      element: CustomerGroupRevenuePage,
    },
    TEAM_SALE_REVENUE: {
      title: 'Doanh thu đội bán hàng',
      path: path.TEAM_SALE_REVENUE,
      element: TeamSaleRevenuePage,
    },
    TRANSACTION_FREQUENCY: {
      title: 'Tần suất giao dịch khách hàng',
      path: path.TRANSACTION_FREQUENCY,
      element: TransactionFrequencyPage,
    },
    MARKET_REPORT: {
      title: 'Độ phủ thị trường',
      path: path.MARKET_COVERAGE,
      element: MarketCoveragePage,
    },
    SALE_LINE_EFFICIENCY: {
      title: 'Hiệu quả tuyến bán hàng',
      path: path.SALE_LINE_EFFICIENCY,
      element: SaleLineEfficiencyPage,
    },
  },
  APPROVE: {
    APPROVE: {
      title: 'Phê duyệt',
      path: path.APPROVE,
      element: ApproveList,
    },
    APPROVE_NEW_CUSTOMER: {
      title: '',
      path: path.APPROVE_NEW_CUSTOMER,
      element: CustomerApprove,
      isHidden: true,
    },
    APPROVE_PRICE_ORDER: {
      title: '',
      path: path.APPROVE_PRICE_ORDER,
      element: PriceOrderApprove,
      isHidden: true,
    },
    APPROVE_PRICE_PURCHASER: {
      title: '',
      path: path.APPROVE_PRICE_PURCHASER,
      element: PricePurchaserApprove,
      isHidden: true,
    },
  },
  SYSTEM: {
    AVERAGE_ORDER: {
      title: 'Trung bình đơn hàng',
      path: path.AVERAGE_ORDER,
      element: AverageOrder,
    },
    SET_APPROVAL: {
      title: 'Thiết lập phê duyệt',
      path: path.SET_APPROVAL,
      element: SetApprovalPage,
    },
    ADD_APPROVAL: {
      title: 'Tạo mới phê duyệt',
      path: path.ADD_APPROVAL,
      element: ApprovalAdjusterPage,
      isHidden: true,
    },
    PERMISSION: {
      title: 'Phân quyền',
      path: path.PERMISSION,
      element: PermissionPage,
    },
    UPDATE_ROLE: {
      title: 'Cập nhật Role - Job Title',
      path: path.UPDATEROLE,
      element: UpdateRole,
    },
    SALES_DEAL: {
      title: 'Chương trình KM',
      path: path.SALES_DEAL,
      element: SaleDeal,
    },
    GOLD_PRICE_MANAGEMENT: {
      title: 'Quản lý giá vàng',
      path: path.GOLD_PRICE_MANAGEMENT,
      element: GoldPriceManagementPage,
    },
    BRANCH_CONFIG: {
      title: 'Thông số chi nhánh',
      path: path.BRANCH_CONFIG,
      element: BranchConfigPage,
    },
    APPROVAL_DETAIL: {
      title: 'Chi tiết phê duyệt',
      path: path.APPROVAL_DETAIL,
      element: DetailSetApproval,
      isHidden: true,
    },
  },
  OPERATION: {
    HO_FOLLOW_PLAN: {
      title: 'Theo dõi KH HO',
      path: path.HO_FOLLOW_PLAN,
      element: HOFollowPlan,
    },
    HO_FOLLOW_PLAN_DETAIL: {
      title: 'Theo dõi KH HO',
      path: path.HO_FOLLOW_PLAN_DETAIL,
      isHidden: true,
      element: HOFollowPlanDetail,
    },
    CN_FOLLOW_PLAN: {
      title: 'Theo dõi KH CN',
      path: path.CN_FOLLOW_PLAN,
      element: CNFollowPlan,
    },
    CN_FOLLOW_PLAN_DETAIL: {
      title: 'Theo dõi KH CN',
      path: path.CN_FOLLOW_PLAN_DETAIL,
      element: CNFollowPlanDetail,
      isHidden: true,
    },
    ROUTE_TRACKING: {
      title: 'Giám sát lộ trình nhân viên',
      path: path.ROUTE_TRACKING,
      element: EmployeeRouteTracking,
    },
  },
  ACCOUNTANT_TREASURER: {
    SALES_INVOICE: {
      title: 'Bảng kê bán hàng',
      path: path.SALES_INVOICE,
      element: SalesInvoicePage,
    },
    PURCHASE_INVOICE: {
      title: 'Bảng dẻ',
      path: path.PURCHASE_INVOICE,
      element: PurchaseInvoicePage,
    },
    PAYMENT_SUMMARY: {
      title: 'Bảng THTT (trước 11/08/2026)',
      path: path.PAYMENT_SUMMARY,
      element: PaymentSummaryPage,
      isHidden: true,
    },
    PAYMENT_SUMMARY_V2: {
      title: 'Bảng tổng hợp TT',
      path: path.PAYMENT_SUMMARY_V2,
      element: PaymentSummaryPageV2,
    },
    PAYMENT_INFO: {
      title: 'Thông tin thanh toán',
      path: path.PAYMENT_INFO,
      element: PaymentInfoPage,
    },
    EINVOICE_HISTORY: {
      title: 'Lịch sử gửi hóa đơn',
      path: path.EINVOICE_HISTORY,
      element: EinvoiceHistoryPage,
    },
    PAYMENT_SUMMARY_DETAIL: {
      title: 'Bảng tổng hợp TT - Chi tiết',
      path: path.PAYMENT_SUMMARY_DETAIL,
      element: DetailPaymentSummaryPage,
      isHidden: true,
    },
    PAYMENT_SUMMARY_DETAIL_V2: {
      title: 'Bảng tổng hợp TT - Chi tiết',
      path: path.PAYMENT_SUMMARY_DETAIL_V2,
      element: DetailPaymentSummaryPageV2,
      isHidden: true,
    },
    SALES_INVOICE_DETAIL: {
      title: 'Bảng kê bán hàng - Chi tiết',
      path: path.SALES_INVOICE_DETAIL,
      element: SalesInvoiceDetailPage,
      isHidden: true,
    },
    // PURCHASE_INVOICE_DETAIL: {
    //   title: 'Bảng dẻ - Chi tiết',
    //   path: path.PURCHASE_INVOICE_DETAIL,
    //   element: PurchaseInvoiceDetailPage,
    //   isHidden: true,
    // },
    SEPARATE_PURCHASE_INVOICE_DETAIL: {
      title: 'Bảng dẻ - tách dẻ',
      path: path.SEPARATE_PURCHASE_INVOICE_DETAIL,
      element: SeparatePurchaseInvoice,
      isHidden: true,
    },
    ADD_NEW_PURCHASE_INVOICE: {
      title: 'Bảng đẻ - Tạo mới',
      path: path.ADD_NEW_PURCHASE_INVOICE,
      element: AddPurchaseInvoice,
      isHidden: true,
    },
    HANDOVER: {
      title: 'Bàn giao',
      path: path.HANDOVER,
      element: HandoverPage,
    },
    ROUTE_COST: {
      title: 'Chi phí tuyến',
      path: path.ROUTE_COST,
      element: RouteCostPage,
    },
    DEBT_LIMIT: {
      title: 'Hạn mức công nợ',
      path: path.DEBT_LIMIT,
      element: DebtLimitPage,
    },
    DEBT_DMS: {
      title: 'Công nợ DMS',
      path: path.DEBT_DMS,
      element: DebtDMSPage,
    },
    DEBT_DMS_DETAIL: {
      title: 'Công nợ KH',
      path: path.DEBT_DMS_DETAIL,
      element: DebtDMSDetailPage,
    },
    DEBT_DMS_CUSTOMER_DETAIL: {
      title: 'Công nợ khách hàng',
      path: path.DEBT_DMS_CUSTOMER_DETAIL,
      element: DebtCustomerDetailPage,
      isHidden: true,
    },
  },
  AML: {
    TERRORIST_LIST: {
      title: 'Danh sách khủng bố',
      path: path.TERRORIST_LIST,
      element: TerroristList,
    },
    TERRORIST_VERIFICATION: {
      title: 'Xác minh khủng bố',
      path: path.TERRORIST_VERIFICATION,
      element: TerroristVerification,
    },
  },
};

const isProd = process.env.REACT_APP_API_BASE_URL?.includes('dms-api.pnj.io');

const useRoutesByRole = () => {
  const { user } = useUser();

  const ROUTES_BY_ROLE = useMemo(() => {
    if (!user?.role) return [];

    let menu: Array<RouteMenu> = [];

    if (user.isHO)
      menu = [
        {
          ...ROUTES.OPERATION,
          children:
            // isProd
            //   ? [ROUTE_ITEMS.OPERATION.ROUTE_TRACKING]
            //   :
            [
              ROUTE_ITEMS.OPERATION.ROUTE_TRACKING,
              ROUTE_ITEMS.OPERATION.HO_FOLLOW_PLAN,
              ROUTE_ITEMS.OPERATION.HO_FOLLOW_PLAN_DETAIL,
              ROUTE_ITEMS.OPERATION.CN_FOLLOW_PLAN,
              ROUTE_ITEMS.OPERATION.CN_FOLLOW_PLAN_DETAIL,
            ],
        },
        {
          ...ROUTES.PLANT,
          children: [
            ROUTE_ITEMS.PLANT.HO_PLAN,
            ROUTE_ITEMS.PLANT.HO_PLAN_DETAIL,
            ROUTE_ITEMS.PLANT.CUSTOMER,
          ],
        },
        ...(!isProd
          ? [
              {
                ...ROUTES.REVENUE_REWARD,
                children: [
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
                  ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
                  ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
                ],
              },
            ]
          : []),
        {
          ...ROUTES.PRODUCT,
          children: [
            ROUTE_ITEMS.PRODUCT.PRODUCT,
            ROUTE_ITEMS.PRODUCT.PRODUCT_SLOC,
            ROUTE_ITEMS.PRODUCT.PRODUCT_DETAIL,
          ],
        },
        {
          ...ROUTES.REPORT,
          children: [
            // ROUTE_ITEMS.REPORT.OVERVIEW_REPORT,
            // ROUTE_ITEMS.REPORT.CUSTOMER_REPORT,
            ROUTE_ITEMS.REPORT.CUSTOMER_REVENUE,
            ROUTE_ITEMS.REPORT.CUSTOMER_GROUP_REVENUE,
            ROUTE_ITEMS.REPORT.TEAM_SALE_REVENUE,
            ROUTE_ITEMS.REPORT.TRANSACTION_FREQUENCY,
            ROUTE_ITEMS.REPORT.MARKET_REPORT,
            ROUTE_ITEMS.REPORT.SALE_LINE_EFFICIENCY,
          ],
        },
        // {
        //   ...ROUTES.REPORT,
        //   children: [
        //     ROUTE_ITEMS.REPORT.OVERVIEW_REPORT,
        //     ROUTE_ITEMS.REPORT.CUSTOMER_REPORT,
        //   ],
        // },
        // {
        //   ...ROUTES.APPROVE,
        //   children: [
        //     ROUTE_ITEMS.APPROVE.APPROVE,
        //     ROUTE_ITEMS.APPROVE.APPROVE_NEW_CUSTOMER,
        //     ROUTE_ITEMS.APPROVE.APPROVE_PRICE_ORDER,
        //     ROUTE_ITEMS.APPROVE.APPROVE_PRICE_PURCHASER,
        //   ],
        // },
        {
          ...ROUTES.ACCOUNTANT_TREASURER,
          children: [
            ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE,
            ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE_DETAIL,
            ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_INFO,
            ROUTE_ITEMS.ACCOUNTANT_TREASURER.EINVOICE_HISTORY,
          ],
        },
        ...(isProd
          ? []
          : [
              {
                ...ROUTES.APPROVE,
                children: [
                  ROUTE_ITEMS.APPROVE.APPROVE,
                  ROUTE_ITEMS.APPROVE.APPROVE_NEW_CUSTOMER,
                  ROUTE_ITEMS.APPROVE.APPROVE_PRICE_ORDER,
                  ROUTE_ITEMS.APPROVE.APPROVE_PRICE_PURCHASER,
                ],
              },
            ]),
        {
          ...ROUTES.AML,
          children: [
            ROUTE_ITEMS.AML.TERRORIST_LIST,
            ROUTE_ITEMS.AML.TERRORIST_VERIFICATION,
          ],
        },
        {
          ...ROUTES.SYSTEM,
          children: [
            ROUTE_ITEMS.SYSTEM.SET_APPROVAL,
            ROUTE_ITEMS.SYSTEM.APPROVAL_DETAIL,
            ROUTE_ITEMS.SYSTEM.ADD_APPROVAL,
            ROUTE_ITEMS.SYSTEM.SALES_DEAL,
            ROUTE_ITEMS.SYSTEM.BRANCH_CONFIG,
          ],
        },
      ];
    else if (user.isAdmin)
      menu = [
        {
          ...ROUTES.OPERATION,
          children:
            // isProd
            //   ? [ROUTE_ITEMS.OPERATION.ROUTE_TRACKING]
            //   :
            [
              ROUTE_ITEMS.OPERATION.ROUTE_TRACKING,
              ROUTE_ITEMS.OPERATION.HO_FOLLOW_PLAN,
              ROUTE_ITEMS.OPERATION.HO_FOLLOW_PLAN_DETAIL,
              ROUTE_ITEMS.OPERATION.CN_FOLLOW_PLAN,
              ROUTE_ITEMS.OPERATION.CN_FOLLOW_PLAN_DETAIL,
            ],
        },
        {
          ...ROUTES.PLANT,
          children: [
            ROUTE_ITEMS.PLANT.HO_PLAN,
            ROUTE_ITEMS.PLANT.HO_PLAN_DETAIL,
            ROUTE_ITEMS.PLANT.CN_PLAN,
            ROUTE_ITEMS.PLANT.CN_PLAN_DETAIL,
            ROUTE_ITEMS.PLANT.SALE_TEAM,
            ROUTE_ITEMS.PLANT.SALE_LINE,
            ROUTE_ITEMS.PLANT.SALE_LINE_TEAM,
            ROUTE_ITEMS.PLANT.SALE_PLAN,
            ROUTE_ITEMS.PLANT.TEAM_DASHBOARD,
            ROUTE_ITEMS.PLANT.CUSTOMER,
          ],
        },
        {
          ...ROUTES.REVENUE_REWARD,
          children: [
            ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
            ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
            ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
            ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
            ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
          ],
        },
        {
          ...ROUTES.PRODUCT,
          children: [
            ROUTE_ITEMS.PRODUCT.PRODUCT,
            ROUTE_ITEMS.PRODUCT.PRODUCT_SLOC,
            ROUTE_ITEMS.PRODUCT.PRODUCT_DETAIL,
          ],
        },
        {
          ...ROUTES.REPORT,
          children:
            // isProd ? []  :
            [
              // ROUTE_ITEMS.REPORT.OVERVIEW_REPORT,
              // ROUTE_ITEMS.REPORT.CUSTOMER_REPORT,
              ROUTE_ITEMS.REPORT.CUSTOMER_REVENUE,
              ROUTE_ITEMS.REPORT.CUSTOMER_GROUP_REVENUE,
              ROUTE_ITEMS.REPORT.TEAM_SALE_REVENUE,
              ROUTE_ITEMS.REPORT.TRANSACTION_FREQUENCY,
              ROUTE_ITEMS.REPORT.MARKET_REPORT,
              ROUTE_ITEMS.REPORT.SALE_LINE_EFFICIENCY,
            ],
        },
        ...[
          {
            ...ROUTES.ACCOUNTANT_TREASURER,
            children: [
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE,
              // ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SEPARATE_PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_INFO,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.EINVOICE_HISTORY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ADD_NEW_PURCHASE_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.HANDOVER,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_LIMIT,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_DMS,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_DMS_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_DMS_CUSTOMER_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ROUTE_COST,
            ],
          },
        ],
        ...(isProd
          ? []
          : [
              {
                ...ROUTES.APPROVE,
                children: [
                  ROUTE_ITEMS.APPROVE.APPROVE,
                  ROUTE_ITEMS.APPROVE.APPROVE_NEW_CUSTOMER,
                  ROUTE_ITEMS.APPROVE.APPROVE_PRICE_ORDER,
                  ROUTE_ITEMS.APPROVE.APPROVE_PRICE_PURCHASER,
                ],
              },
            ]),
        {
          ...ROUTES.AML,
          children: [
            ROUTE_ITEMS.AML.TERRORIST_LIST,
            ROUTE_ITEMS.AML.TERRORIST_VERIFICATION,
          ],
        },
        {
          ...ROUTES.SYSTEM,
          children: [
            // ROUTE_ITEMS.SYSTEM.AVERAGE_ORDER,
            ROUTE_ITEMS.SYSTEM.GOLD_PRICE_MANAGEMENT,
            ROUTE_ITEMS.SYSTEM.SET_APPROVAL,
            ROUTE_ITEMS.SYSTEM.APPROVAL_DETAIL,
            ROUTE_ITEMS.SYSTEM.ADD_APPROVAL,
            ROUTE_ITEMS.SYSTEM.SALES_DEAL,
            ROUTE_ITEMS.SYSTEM.PERMISSION,
            ROUTE_ITEMS.SYSTEM.UPDATE_ROLE,
            ROUTE_ITEMS.SYSTEM.BRANCH_CONFIG,
          ],
        },
      ];
    else if (user.isCN || user?.isQLD || user?.isQTCN)
      menu = [
        {
          ...ROUTES.OPERATION,
          children:
            // isProd
            //   ? [ROUTE_ITEMS.OPERATION.ROUTE_TRACKING]
            //   :
            [
              ROUTE_ITEMS.OPERATION.ROUTE_TRACKING,
              ROUTE_ITEMS.OPERATION.HO_FOLLOW_PLAN,
              ROUTE_ITEMS.OPERATION.HO_FOLLOW_PLAN_DETAIL,
              ROUTE_ITEMS.OPERATION.CN_FOLLOW_PLAN,
              ROUTE_ITEMS.OPERATION.CN_FOLLOW_PLAN_DETAIL,
            ],
        },
        {
          ...ROUTES.PLANT,
          children: [
            ROUTE_ITEMS.PLANT.HO_PLAN,
            ROUTE_ITEMS.PLANT.HO_PLAN_DETAIL,
            ROUTE_ITEMS.PLANT.CN_PLAN,
            ROUTE_ITEMS.PLANT.CN_PLAN_DETAIL,
            ROUTE_ITEMS.PLANT.SALE_TEAM,
            ROUTE_ITEMS.PLANT.SALE_LINE,
            ROUTE_ITEMS.PLANT.SALE_LINE_TEAM,
            ROUTE_ITEMS.PLANT.SALE_PLAN,
            ROUTE_ITEMS.PLANT.TEAM_DASHBOARD,
            ROUTE_ITEMS.PLANT.CUSTOMER,
          ],
        },
        ...(!isProd
          ? [
              {
                ...ROUTES.REVENUE_REWARD,
                children: [
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
                  ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
                  ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
                ],
              },
            ]
          : []),
        {
          ...ROUTES.PRODUCT,
          children: [
            ROUTE_ITEMS.PRODUCT.PRODUCT,
            ROUTE_ITEMS.PRODUCT.PRODUCT_SLOC,
            ROUTE_ITEMS.PRODUCT.PRODUCT_DETAIL,
          ],
        },
        {
          ...ROUTES.REPORT,
          children:
            // isProd
            //   ? []
            //   :
            user?.isQLD
              ? []
              : [
                  // ROUTE_ITEMS.REPORT.OVERVIEW_REPORT,
                  // ROUTE_ITEMS.REPORT.CUSTOMER_REPORT,
                  ROUTE_ITEMS.REPORT.CUSTOMER_REVENUE,
                  ROUTE_ITEMS.REPORT.CUSTOMER_GROUP_REVENUE,
                  ROUTE_ITEMS.REPORT.TEAM_SALE_REVENUE,
                  ROUTE_ITEMS.REPORT.TRANSACTION_FREQUENCY,
                  ROUTE_ITEMS.REPORT.MARKET_REPORT,
                  ROUTE_ITEMS.REPORT.SALE_LINE_EFFICIENCY,
                ],
        },
        // {
        //   ...ROUTES.APPROVE,
        //   children: [
        //     ROUTE_ITEMS.APPROVE.APPROVE,
        //     ROUTE_ITEMS.APPROVE.APPROVE_NEW_CUSTOMER,
        //     ROUTE_ITEMS.APPROVE.APPROVE_PRICE_ORDER,
        //     ROUTE_ITEMS.APPROVE.APPROVE_PRICE_PURCHASER,
        //   ],
        // },
        ...[
          {
            ...ROUTES.ACCOUNTANT_TREASURER,
            children: [
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE,
              // ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SEPARATE_PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_INFO,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.EINVOICE_HISTORY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ADD_NEW_PURCHASE_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.HANDOVER,
            ],
          },
        ],
        // {
        //   ...ROUTES.ACCOUNTANT_TREASURER,
        //   children: [
        //     ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE,
        //     ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE_DETAIL,
        //   ],
        // },

        {
          ...ROUTES.AML,
          children: user?.isQTCN
            ? [ROUTE_ITEMS.AML.TERRORIST_VERIFICATION]
            : [
                ROUTE_ITEMS.AML.TERRORIST_LIST,
                ROUTE_ITEMS.AML.TERRORIST_VERIFICATION,
              ],
        },
        ...(isProd
          ? []
          : [
              {
                ...ROUTES.APPROVE,
                children: [
                  ROUTE_ITEMS.APPROVE.APPROVE,
                  ROUTE_ITEMS.APPROVE.APPROVE_NEW_CUSTOMER,
                  ROUTE_ITEMS.APPROVE.APPROVE_PRICE_ORDER,
                  ROUTE_ITEMS.APPROVE.APPROVE_PRICE_PURCHASER,
                ],
              },
            ]),

        {
          ...ROUTES.SYSTEM,
          children: [
            // ROUTE_ITEMS.SYSTEM.AVERAGE_ORDER,
            ROUTE_ITEMS.SYSTEM.GOLD_PRICE_MANAGEMENT,
            ROUTE_ITEMS.SYSTEM.SET_APPROVAL,
            ROUTE_ITEMS.SYSTEM.APPROVAL_DETAIL,
            ROUTE_ITEMS.SYSTEM.ADD_APPROVAL,
            ROUTE_ITEMS.SYSTEM.BRANCH_CONFIG,
          ],
        },
      ];
    else if (user.isSale)
      menu = [
        {
          ...ROUTES.OPERATION,
          children: [ROUTE_ITEMS.OPERATION.ROUTE_TRACKING],
        },
        {
          ...ROUTES.PLANT,
          children: [
            ROUTE_ITEMS.PLANT.SALE_TEAM,
            ROUTE_ITEMS.PLANT.SALE_LINE,
            ROUTE_ITEMS.PLANT.SALE_LINE_TEAM,
            ROUTE_ITEMS.PLANT.SALE_PLAN,
            ROUTE_ITEMS.PLANT.TEAM_DASHBOARD,
            ROUTE_ITEMS.PLANT.CUSTOMER,
          ],
        },
        ...(!isProd
          ? [
              {
                ...ROUTES.REVENUE_REWARD,
                children: [
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
                  ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
                  ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
                ],
              },
            ]
          : []),
        {
          ...ROUTES.PRODUCT,
          children: [
            ROUTE_ITEMS.PRODUCT.PRODUCT,
            ROUTE_ITEMS.PRODUCT.PRODUCT_SLOC,
            ROUTE_ITEMS.PRODUCT.PRODUCT_DETAIL,
          ],
        },
        {
          ...ROUTES.REPORT,
          children: isProd
            ? []
            : [
                // ROUTE_ITEMS.REPORT.OVERVIEW_REPORT,
                // ROUTE_ITEMS.REPORT.CUSTOMER_REPORT,
                ROUTE_ITEMS.REPORT.CUSTOMER_REVENUE,
                ROUTE_ITEMS.REPORT.CUSTOMER_GROUP_REVENUE,
                ROUTE_ITEMS.REPORT.TEAM_SALE_REVENUE,
                ROUTE_ITEMS.REPORT.TRANSACTION_FREQUENCY,
                ROUTE_ITEMS.REPORT.MARKET_REPORT,
                ROUTE_ITEMS.REPORT.SALE_LINE_EFFICIENCY,
              ],
        },
        ...[
          {
            ...ROUTES.ACCOUNTANT_TREASURER,
            children: [
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_INFO,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ROUTE_COST,
            ],
          },
        ],
        // {
        //   ...ROUTES.ACCOUNTANT_TREASURER,
        //   children: [
        //     ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE,
        //     ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE_DETAIL,
        //   ],
        // },
      ];
    else if (user.isAccountant)
      menu = [
        {
          ...ROUTES.PLANT,
          children: [ROUTE_ITEMS.PLANT.CUSTOMER],
        },
        // ...(!isProd
        //   ? [
        //       {
        //         ...ROUTES.REVENUE_REWARD,
        //         children: [
        //           ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
        //           ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
        //           ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
        //           ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
        //           ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
        //         ],
        //       },
        //     ]
        //   : []),
        {
          ...ROUTES.PRODUCT,
          children: [
            ROUTE_ITEMS.PRODUCT.PRODUCT,
            ROUTE_ITEMS.PRODUCT.PRODUCT_SLOC,
            ROUTE_ITEMS.PRODUCT.PRODUCT_DETAIL,
          ],
        },
        {
          ...ROUTES.REPORT,
          children: !isProd
            ? []
            : [
                // ROUTE_ITEMS.REPORT.OVERVIEW_REPORT,
                // ROUTE_ITEMS.REPORT.CUSTOMER_REPORT,
                //** */
                // ROUTE_ITEMS.REPORT.CUSTOMER_REVENUE,
                // ROUTE_ITEMS.REPORT.CUSTOMER_GROUP_REVENUE,
                // ROUTE_ITEMS.REPORT.TEAM_SALE_REVENUE,
                // ROUTE_ITEMS.REPORT.TRANSACTION_FREQUENCY,
                // ROUTE_ITEMS.REPORT.MARKET_REPORT,
                // ROUTE_ITEMS.REPORT.SALE_LINE_EFFICIENCY,
              ],
        },
        ...[
          {
            ...ROUTES.ACCOUNTANT_TREASURER,
            children: [
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE,
              // ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SEPARATE_PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_INFO,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.EINVOICE_HISTORY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ADD_NEW_PURCHASE_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.HANDOVER,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_LIMIT,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_DMS,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_DMS_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.DEBT_DMS_CUSTOMER_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ROUTE_COST,
            ],
          },
        ],
        // ...(isProd
        //   ? []
        //   : [
        //       {
        //         ...ROUTES.APPROVE,
        //         children: [
        //           ROUTE_ITEMS.APPROVE.APPROVE,
        //           ROUTE_ITEMS.APPROVE.APPROVE_NEW_CUSTOMER,
        //           ROUTE_ITEMS.APPROVE.APPROVE_PRICE_ORDER,
        //           ROUTE_ITEMS.APPROVE.APPROVE_PRICE_PURCHASER,
        //         ],
        //       },
        //     ]),
        {
          ...ROUTES.SYSTEM,
          children: [
            // ROUTE_ITEMS.SYSTEM.AVERAGE_ORDER,
            ROUTE_ITEMS.SYSTEM.GOLD_PRICE_MANAGEMENT,
          ],
        },
      ];
    else if (user.isStorekeeper)
      menu = [
        ...(!isProd
          ? [
              {
                ...ROUTES.REVENUE_REWARD,
                children: [
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
                  ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
                  ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
                  ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
                ],
              },
            ]
          : []),
        {
          ...ROUTES.PRODUCT,
          children: [
            ROUTE_ITEMS.PRODUCT.PRODUCT,
            ROUTE_ITEMS.PRODUCT.PRODUCT_SLOC,
            ROUTE_ITEMS.PRODUCT.PRODUCT_DETAIL,
          ],
        },
        {
          ...ROUTES.REPORT,
          children: isProd
            ? []
            : [
                // ROUTE_ITEMS.REPORT.OVERVIEW_REPORT,
                // ROUTE_ITEMS.REPORT.CUSTOMER_REPORT,
                //** */
                ROUTE_ITEMS.REPORT.CUSTOMER_REVENUE,
                ROUTE_ITEMS.REPORT.CUSTOMER_GROUP_REVENUE,
                ROUTE_ITEMS.REPORT.TEAM_SALE_REVENUE,
                ROUTE_ITEMS.REPORT.TRANSACTION_FREQUENCY,
                ROUTE_ITEMS.REPORT.MARKET_REPORT,
                ROUTE_ITEMS.REPORT.SALE_LINE_EFFICIENCY,
              ],
        },
        ...[
          {
            ...ROUTES.ACCOUNTANT_TREASURER,
            children: [
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE,
              // ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SEPARATE_PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_INFO,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.EINVOICE_HISTORY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ADD_NEW_PURCHASE_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.HANDOVER,
            ],
          },
        ],
      ];
    else if (user.isTreasurer)
      menu = [
        ...[
          ...(!isProd
            ? [
                {
                  ...ROUTES.REVENUE_REWARD,
                  children: [
                    ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
                    ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
                    ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
                    ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
                    ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
                  ],
                },
              ]
            : []),
          {
            ...ROUTES.ACCOUNTANT_TREASURER,
            children: [
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SALES_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE,
              // ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.SEPARATE_PURCHASE_INVOICE_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_SUMMARY_DETAIL_V2,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.PAYMENT_INFO,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.EINVOICE_HISTORY,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.ADD_NEW_PURCHASE_INVOICE,
              ROUTE_ITEMS.ACCOUNTANT_TREASURER.HANDOVER,
            ],
          },
        ],
      ];
    else if (user.isNS)
      menu = [
        ...[
          {
            ...ROUTES.REVENUE_REWARD,
            children: [
              ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC,
              ROUTE_ITEMS.REVENUE_REWARD.REWARD_CALC_SETUP,
              ROUTE_ITEMS.REVENUE_REWARD.GROSS_PROFIT,
              ROUTE_ITEMS.REVENUE_REWARD.GROUP_ROLE,
              ROUTE_ITEMS.REVENUE_REWARD.REWARD_INFO,
            ],
          },
        ],
      ];
    else if (user.isPC || user?.role === 'pc')
      menu = [
        {
          ...ROUTES.PLANT,
          children: [ROUTE_ITEMS.PLANT.CUSTOMER],
        },
        {
          ...ROUTES.AML,
          children: [
            ROUTE_ITEMS.AML.TERRORIST_LIST,
            ROUTE_ITEMS.AML.TERRORIST_VERIFICATION,
          ],
        },
      ];
    else if (user.isKTD)
      menu = [
        {
          ...ROUTES.PLANT,
          children: [ROUTE_ITEMS.PLANT.CUSTOMER],
        },
        {
          ...ROUTES.ACCOUNTANT_TREASURER,
          children: [
            ROUTE_ITEMS.ACCOUNTANT_TREASURER.PURCHASE_INVOICE,
            ROUTE_ITEMS.ACCOUNTANT_TREASURER.SEPARATE_PURCHASE_INVOICE_DETAIL,
            ROUTE_ITEMS.ACCOUNTANT_TREASURER.ADD_NEW_PURCHASE_INVOICE,
          ],
        },
      ];
    return menu.filter((item) => item?.children?.length);
  }, [
    user?.isAccountant,
    user?.isAdmin,
    user?.isCN,
    user?.isHO,
    user?.isQLD,
    user?.isQTCN,
    user?.isSale,
    user?.role,
    user?.isStorekeeper,
    user?.isTreasurer,
    user?.isNS,
    user?.isPC,
    user?.isKTD,
  ]);

  return ROUTES_BY_ROLE;
};

export default useRoutesByRole;
